<template>
    <div>
        <div v-if="allowRedirect && !hasActiveSubscription && hasMultiplePausedSubscriptions">
            <p v-if="showText" v-text="$t('PAUSE_DELIVERIES_RESUME_MULTIPLE_INSTRUCTIONS')"></p>
            <router-link :to="{ name: 'account.delivery-addresses' }">
                <button type="submit" class="btn--full-width btn btn--primary unpause-button" v-text="$t('PAUSE_DELIVERIES_RESUME_MULTIPLE_BUTTON')"></button>
            </router-link>
        </div>
        <div v-else class="">
            <p v-if="showText" v-text="$t('PAUSE_DELIVERIES_RESUME_INSTRUCTIONS')"></p>
            <button
                type="submit"
                @click="resumeSubscription"
                class="btn--full-width btn btn--primary"
                v-text="$t('PAUSE_DELIVERIES_RESUME')"
                :class="positionClass ? `${positionClass} unpause-button` : 'unpause-button'"></button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

export default {
    name: 'ResumeDeliveries',
    props: {
        allowRedirect: {
            required: false,
            type: Boolean,
            default: false,
        },
        subscription: {
            required: true,
            type: Object,
        },
        showText: {
            required: false,
            type: Boolean,
            default: true,
        },
        positionClass: {
            required: false,
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            hasActiveSubscription: 'subscription/hasActiveSubscription',
            hasMultiplePausedSubscriptions: 'subscription/hasMultiplePausedSubscriptions',
        }),
    },
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
            subscriptionService: new SubscriptionService(),
        };
    },
    methods: {
        fetchData() {
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
            this.$store.dispatch('address/fetchAllAddresses', true);
            this.$store.dispatch('scheduledOrder/fetchAllScheduledOrders', true);
        },
        resumeSubscription() {
            this.subscriptionService.continueSubscription(this.subscription.id)
                .then(() => {
                    this.$emit('deliveries-resumed');
                    this.fetchData();
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
};
</script>

<style lang="scss" scoped>
    .unpause-button {
        font-size: 20px;
    }
    .next-delivery-modal {
        background-color: theme('colors.shop.green');
        border-radius: 5px;
        width: 66%;
    }
</style>
